import BIKE_ATTRIBUTES from './bike-attributes'
import AIMEOS from '@/js/helper/aimeos-constants.js'
import { TYPES as PROP_TYPES } from '@/js/helper/aimeos-product-property-constants.js'

import { flatten } from 'lodash-es'

export const CONSTANTS = {
  CATALOG_TYPE: {
    ALL: 'DP2020_FULL',
    // BIKES: 'DP2020_BIKES',
    // CURRENT: 'DP2020_BIKES',
    // OUTLET: 'DP2020_OUTLET',
    BIKES: 'DP2020_FULL',
    CURRENT: 'DP2020_FULL',
    OUTLET: 'DP2020_FULL',
    SERVICE: 'DP2020_SERVICE',
    ARCHIVE: 'DP2020_ARCHIVE',
    ACCESSORIES: 'DP2020_ACCESSORIES',
  },
  SCOPE: {
    ALL: 'ALL',
    DEBUG: 'DEBUG',
    BIKES: 'BIKES',
    BIKES_ITEMS: 'BIKES_ITEMS',
    CURRENT: 'CURRENT',
    OUTLET: 'OUTLET',
    SERVICE: 'SERVICE',
    ARCHIVE: 'ARCHIVE',
    ACCESSORIES: 'ACCESSORIES',
    PART_SALE: 'PART_SALE',
    // COMPARE: 'COMPARE',
  },

  FE_SCOPE_TO_PRODUCT_TYPE: {
    ALL: AIMEOS.PRODUCTS.TYPE.SELECT,
    DEBUG: AIMEOS.PRODUCTS.TYPE.SELECT,
    BIKES: AIMEOS.PRODUCTS.TYPE.SELECT,
    BIKES_ITEMS: AIMEOS.PRODUCTS.TYPE.DEFAULT,
    CURRENT: AIMEOS.PRODUCTS.TYPE.SELECT,
    OUTLET: AIMEOS.PRODUCTS.TYPE.SELECT,
    SERVICE: AIMEOS.PRODUCTS.TYPE.SELECT,
    ARCHIVE: AIMEOS.PRODUCTS.TYPE.SELECT,
    ACCESSORIES: AIMEOS.PRODUCTS.TYPE.SELECT,
    PART_SALE: AIMEOS.PRODUCTS.TYPE.DEFAULT,
  },

  FE_SCOPE_MAPPING: {
    ALL: 'ALL',
    DEBUG: 'DEBUG',
    BIKES: 'BIKES',
    BIKES_ITEMS: 'BIKES',
    CURRENT: 'CURRENT',
    OUTLET: 'OUTLET',
    SERVICE: 'SERVICE',
    ARCHIVE: 'ARCHIVE',
    ACCESSORIES: 'ACCESSORIES',
  },

  ARTICLETYPE_CODE: {
    BIKE: 'bike',
    PART: 'part',
    ACCESSORY: 'accessory',
  },

  ITEM_TYPE: {
    SHOP: 'shop',
    ARCHIVE: 'archive',
    DEALERBOOK: 'dealerbook',
  },

  IS_OUTLET: {
    ALL: 'all',
    DEBUG: 'debug',
    CURRENT: 'current',
    BIKES: 'bikes',
    BIKES_ITEMS: 'bikes',
    OUTLET: 'outlet',
    SERVICE: 'service',
    ARCHIVE: 'archive',
    ACCESSORIES: 'accessories',
    PART_SALE: 'service',
  },
}

export const SCOPE_TO_ARTICLETYPE = {
  [CONSTANTS.SCOPE.BIKES]: [CONSTANTS.ARTICLETYPE_CODE.BIKE],
  [CONSTANTS.SCOPE.BIKES_ITEMS]: [CONSTANTS.ARTICLETYPE_CODE.BIKE],
  [CONSTANTS.SCOPE.SERVICE]: [CONSTANTS.ARTICLETYPE_CODE.PART],
  [CONSTANTS.SCOPE.PART_SALE]: [CONSTANTS.ARTICLETYPE_CODE.PART],
  [CONSTANTS.SCOPE.ACCESSORIES]: [CONSTANTS.ARTICLETYPE_CODE.ACCESSORY],
  [CONSTANTS.SCOPE.ARCHIVE]: [CONSTANTS.ARTICLETYPE_CODE.BIKE],
  [CONSTANTS.SCOPE.ALL]: [],
}

export const TYPE = {
  ARTICLE_TYPE: 'ArticleType',
  ITEM_FRAME_SIZE: 'ItemFrameSize',
  PRODUCT_VARIANTS: 'ProductVariants',
  ITEM_TYPE: 'ItemType',
  ZZCA_CLIENT: 'ZzcaClient',
  CATEGORIES: 'Categories',
  CATEGORY: 'Category',
  PIM_CATEGORY: 'PimCategory',
  SEARCH_TEXT: 'SearchText',
  // SEARCH_SKU: 'SearchSku',
  SEARCH_LIMIT: 'SearchLimit',
  SEARCH_OFFSET: 'SearchOffset',
  SEARCH_PAGE: 'SearchPage',
  SEARCH_INCLUDED: 'SearchIncluded',
  SEARCH_PRICE: 'SearchPrice',
  STOCK: 'Stock',
  PRODUCT_BIDEX_COMMODITY_GROUP: 'ProductBidexCommodityGroup',
  EBIKE_SYSTEM_AND_MODEL: 'EbikeSystemAndModel',
  ITEM_BRAND_ARCHIV: 'ItemBrandArchiv',
  HAS_OUTLET_SALES_PRICE: 'HasOutletSalesPrice',
}

export const GROUPS = {
  [TYPE.ITEM_FRAME_SIZE]: [
    BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_SIZE_CM,
    BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_SIZE_CODE,
  ],
  [TYPE.PRODUCT_VARIANTS]: [
    BIKE_ATTRIBUTES.TYPE.PRODUCT_VARIANTS_CURRENT,
    BIKE_ATTRIBUTES.TYPE.PRODUCT_VARIANTS_OUTLET,
    BIKE_ATTRIBUTES.TYPE.ARCHIVE_ITEM,
    BIKE_ATTRIBUTES.TYPE.ZZCA_CLIENT,
  ],
  // [TYPE.EBIKE_SYSTEM_AND_MODEL]: [
  //   BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_AND_MODEL,
  //   BIKE_ATTRIBUTES.TYPE.EBIKE_ENGINE_MODEL,
  //   BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_BRAND,
  // ],
}

export const TYPE_TO_GROUP = Object.entries(GROUPS).reduce((result, [group, types]) => {
  types.forEach(type => {
    result.set(type, group)
  })
  return result
}, new Map())

export const GROUP_CONFIG = {
  [TYPE.ITEM_FRAME_SIZE]: {
    NEEDS_ALL_ATTRIBUTES: true,
  },
  [TYPE.EBIKE_SYSTEM_AND_MODEL]: {
    NEEDS_ALL_ATTRIBUTES: true,
  },
}

// export const ALL_PARAMS = {
//   ...BIKE_ATTRIBUTES.TYPE,
//   ...TYPE,
// }

export const CONFIG = {
  SEARCH_QUERY_MIN_LENGTH: 2,
  FILTER_RESET_EXCLUDES: [TYPE.SEARCH_TEXT],
}

export const DEFAULTS = {
  [TYPE.SEARCH_INCLUDED]: 'media,price,product/property,listattributes',
  [TYPE.SEARCH_LIMIT]: 50,
  [TYPE.SEARCH_OFFSET]: 0,
  [TYPE.SEARCH_PAGE]: 1,
}

export const DEFAULT_SET = {
  [CONSTANTS.SCOPE.ALL]: {},
  [CONSTANTS.SCOPE.CURRENT]: {},
  [CONSTANTS.SCOPE.OUTLET]: {},
  [CONSTANTS.SCOPE.BIKES]: {},
  [CONSTANTS.SCOPE.BIKES_ITEMS]: {},
  [CONSTANTS.SCOPE.SERVICE]: {},
  [CONSTANTS.SCOPE.PART_SALE]: {},
  [CONSTANTS.SCOPE.ACCESSORIES]: {},
}

export const GROUPED = flatten(Object.values(GROUPS))

export const PROP_TYPE_SCOPE = {
  [PROP_TYPES.PRODUCT_VARIANTS_CURRENT]: CONSTANTS.SCOPE.CURRENT,
  [PROP_TYPES.PRODUCT_VARIANTS_OUTLET]: CONSTANTS.SCOPE.OUTLET,
  [PROP_TYPES.ARCHIVE_ITEM]: CONSTANTS.SCOPE.ARCHIVE,
  ALL: CONSTANTS.SCOPE.ALL,
}

export const DETAIL_PAGE_SEARCH_HITS_PARENT_EXCLUDES = [BIKE_ATTRIBUTES.TYPE.ZZCA_CLIENT]

// export const SITE_CONTROL_SCOPES = [
//   CONSTANTS.SCOPE.BIKES,
//   CONSTANTS.SCOPE.CURRENT,
//   CONSTANTS.SCOPE.OUTLET,
//   CONSTANTS.SCOPE.SERVICE,
// ]

export default {
  ...CONSTANTS,
  CONFIG,
  DEFAULTS,
  DEFAULT_SET,
  TYPE,
  GROUPS,
  GROUP_CONFIG,
  GROUPED,
  PROP_TYPE_SCOPE,
  DETAIL_PAGE_SEARCH_HITS_PARENT_EXCLUDES,
  SCOPE_TO_ARTICLETYPE,
  // SITE_CONTROL_SCOPES,
}
